"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYoutubeIDFromURL = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Modal_1 = __importDefault(require("../Modal"));
const getYoutubeIDFromURL = (url) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
};
exports.getYoutubeIDFromURL = getYoutubeIDFromURL;
/**
 * Video
 * @block
 * @requiresHooks
 */
const Video = ({ className, classNames = [], url, oembed, poster, playLabel = 'Play video', autoPlay = false, }) => {
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(autoPlay);
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)(null);
    let embedURL = '';
    let thumbURL = poster ? poster.src : '';
    (0, react_1.useEffect)(() => {
        if (!ref || !ref.current) {
            return;
        }
        if (url && !oembed) {
            const video = ref.current;
            video.addEventListener('play', () => {
                setIsPlaying(true);
            });
            video.addEventListener('pause', () => {
                setIsPlaying(false);
            });
        }
    }, [ref, url, oembed]);
    if (oembed) {
        const urlMatches = oembed.match(/\bhttps?:\/\/\S+/gi);
        if (urlMatches && urlMatches.length > 0) {
            embedURL = urlMatches[0];
            if (embedURL.indexOf('youtube.com/') > -1 ||
                embedURL.indexOf('youtu.be/') > -1) {
                if (!thumbURL) {
                    thumbURL = `https://i1.ytimg.com/vi/${(0, exports.getYoutubeIDFromURL)(embedURL)}/hqdefault.jpg`;
                }
            }
        }
    }
    return (react_1.default.createElement("div", { className: className ||
            (0, classnames_1.default)('video', isPlaying && 'video--playing', thumbURL && 'video--poster', ...classNames), style: !isPlaying && thumbURL
            ? { backgroundImage: `url("${thumbURL}")` }
            : {} },
        (url && url.src && !oembed) && (react_1.default.createElement("video", { ref: ref, controls: true, poster: poster === null || poster === void 0 ? void 0 : poster.src, autoPlay: autoPlay },
            react_1.default.createElement("source", { src: url.src, type: "video/mp4" }),
            "Your browser does not support the video tag.")),
        (oembed && showModal) && react_1.default.createElement(Modal_1.default, { className: "modal--video", onCancel: () => setShowModal(false), headerClassNames: [], bodyClassNames: [], showCancel: false, showSubmit: false },
            react_1.default.createElement("div", { className: "video__embed", dangerouslySetInnerHTML: {
                    __html: `${oembed}`,
                } })),
        !isPlaying && (react_1.default.createElement("button", { className: "btn-play", onClick: () => {
                if (oembed) {
                    setShowModal(true);
                }
                else {
                    ref.current &&
                        ref.current.play();
                }
            } }, playLabel))));
};
exports.default = Video;
